<template>
   <validation-provider
    :name="validatorName"
    :rules="rules"
    v-slot="validationContext"
    style="display: block; width: fit-content;"
    >
        <label :class="labelClass" :for="id">{{label}} <span class="additonal-msg">{{additionalMsg}}</span></label>
        <b-input-group :prepend="prepend" class="mb-2 mr-sm-2 mb-sm-0 inp-grp">
            <b-form-input 
                :type="inputType" 
                :id="id"
                :name="name"
                :state="getValidationState(validationContext)"
                :aria-describedby="description"
                @input="changeInput($event, validationContext)"
                v-model="value"
                :disabled=disabled
                :step="step"
                :min="min"
                :max="max"
                :title="title"
            >
            </b-form-input>
        <b-form-invalid-feedback :id="description">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
        </b-input-group>
    </validation-provider>
</template>

<script>
export default {
    props : {
        id: String,
        name: String,
        label: String,
        labelClass: String,
        description: String,
        validatorName: String,
        rules:{
            required: Boolean,
            min: Number,
            max: Number,
            regex: String,
            max_value: Number,
            min_value: Number
        },
        additionalMsg: String,
        inputType: String,
        modelValue: String,
        disabled:Boolean,
        step: Number,
        min: String,
        max: String,
        title: String,
        prepend: String
    },
    emits: ['update:modelValue'],
    methods:{
        getValidationState({ dirty, validated, valid = null }) {
            return dirty || validated ? valid : null;
        },
        changeInput: async function (value,{validate}) {
          await this.updateinput(value,validate);
        //other logic not relevant to the issue
        },
        async updateinput(value,validate) {
            await validate(value);
        }
    },
    computed:{
        value: {
            get() {
                return this.modelValue
            },
            set(value) {
                this.$emit('update:modelValue', value)
            }
        }
    }
}
</script>

<style>
 .additonal-msg{
     font-size: 11px;
    color: #b32649;
 }
 .valuelabel{
    display: none !important;
 }
 .inp-grp {
    width: 75% !important;
 }
</style>

